import React, { ReactNode } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { DialogProps } from '@mui/material/Dialog';

interface Props extends Omit<DialogProps, 'open'> {
  open: boolean;
  handleClose: () => void;
  handleSubmit?: () => void;
  paperProps?: object;
  dialogTitle?: string;
  dialogContent?: string | ReactNode;
  hideTitle?: boolean;
  hideActions?: boolean;
  hideBack?: boolean;
  hideSubmit?: boolean;
  labelBack?: string;
  labelNext?: string;
}

const AlertDialog: React.FC<Props> = ({
  open,
  handleClose,
  paperProps,
  hideTitle = false,
  dialogTitle = 'Dialog',
  dialogContent,
  hideActions = false,
  hideBack = false,
  labelBack = 'Disagree',
  hideSubmit = false,
  handleSubmit,
  labelNext = 'Agree',
  ...props
}) => {
  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{ ...paperProps }}
        {...props}>
        <DialogTitle id="alert-dialog-title" hidden={hideTitle}>
          {dialogTitle}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {dialogContent}
          </DialogContentText>
        </DialogContent>
        <div hidden={hideActions}>
          <DialogActions>
            <div hidden={hideBack}>
              <Button onClick={handleClose} color="primary">
                {labelBack}
              </Button>
            </div>
            <div hidden={hideSubmit}>
              <Button onClick={handleSubmit} color="primary" autoFocus>
                {labelNext}
              </Button>
            </div>
          </DialogActions>
        </div>
      </Dialog>
    </div>
  );
};

AlertDialog.displayName = 'AlertDialog';

export default AlertDialog;
